exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);", ""]);
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!./css/custom.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!./css/dashboard.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!../node_modules/angular2-toaster/toaster.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n/*@import '~@angular/material/prebuilt-themes/deeppurple-amber.css';*/\r\n.headerTitle .mat-dialog-container{\r\n    padding: 0 !important;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/~/css-loader?{"sourceMap":false,"importLoaders":1}!D:/UI-PROJECTS/Helpline1097-UI/~/postcss-loader?{"ident":"postcss"}!D:/UI-PROJECTS/Helpline1097-UI/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2